import React, {MouseEvent} from "react";
import {observer} from "mobx-react-lite";
import styled, {css} from "styled-components";
import {CheckboxCheckedIcon} from "../../assets/svg/checkbox-checked.icon";
import {CheckboxUncheckedIcon} from "../../assets/svg/checkbox-unchecked.icon";

const CheckContainerBox = styled.div<{$flexDirection: string; $disabled: boolean}>`
    display: flex;
    flex-direction: ${props => props.$flexDirection};
    align-items: center;
    gap: ${props => props.theme.spacing.flexGap12};
    
    ${props => props.$disabled
        ? css`
                opacity: 0.5;
                cursor: not-allowed;
        `    
        : css`
            cursor: pointer;
        `
    }
`

export type CheckBoxLabelPlacement = 'start' | 'end' | 'top' | 'bottom';

interface CheckboxComponentProps {
    className?: string;
    checked: boolean;
    onChange?: (isChecked: boolean) => void;
    onClick?: (event: MouseEvent<HTMLElement>) => void;
    disabled?: boolean;
    label?: string | React.ReactElement;
    labelPlacement?: CheckBoxLabelPlacement;
    isReadOnly?: boolean;
    mode?: "ios" | "md";
}
export const CheckboxComponent: React.FC<CheckboxComponentProps> = observer((props) => {
    const onClickHandler = (event: MouseEvent<HTMLElement>) => {
        if(props.isReadOnly) {
            event.preventDefault();
        }

        if(props.onChange) {
            props.onChange(!props.checked)
        }

        if(props.onClick) {
            props.onClick(event);
        }

    }

    const renderCheckMark = () => {
        if(props.checked) {
            return (<CheckboxCheckedIcon/>)
        } else {
            return (<CheckboxUncheckedIcon/>)
        }
    }

    let flexDirection: string;

    switch (props.labelPlacement) {
        case "start":
            flexDirection = "row-reverse";
            break;
        case "top":
            flexDirection = "column-reverse";
            break;
        case "bottom":
            flexDirection = "column";
            break;
        default:
            flexDirection = "row";
            break

    }


    return (
        <CheckContainerBox $flexDirection={flexDirection}
                           $disabled={Boolean(props.disabled)}
                           className={props.className}
                           onClick={onClickHandler}>
            {renderCheckMark()}
            {props.label}
        </CheckContainerBox>

    )
});
